/**
 * @generated SignedSource<<89581a7788e724be5a71f16f5ad755c9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrderEditInvoiceUploadMutation$variables = {
  file: any;
  id: string;
};
export type OrderEditInvoiceUploadMutation$data = {
  readonly uploadOrderInvoice: {
    readonly invoice: {
      readonly " $fragmentSpreads": FragmentRefs<"StoredFile_file">;
    } | null;
  };
};
export type OrderEditInvoiceUploadMutation = {
  response: OrderEditInvoiceUploadMutation$data;
  variables: OrderEditInvoiceUploadMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "file"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "kind": "Variable",
    "name": "file",
    "variableName": "file"
  },
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "OrderEditInvoiceUploadMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Order",
        "kind": "LinkedField",
        "name": "uploadOrderInvoice",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StoredFile",
            "kind": "LinkedField",
            "name": "invoice",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "StoredFile_file"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "OrderEditInvoiceUploadMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Order",
        "kind": "LinkedField",
        "name": "uploadOrderInvoice",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StoredFile",
            "kind": "LinkedField",
            "name": "invoice",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fileName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "size",
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fd48f68eeb605416f359abbc960cf046",
    "id": null,
    "metadata": {},
    "name": "OrderEditInvoiceUploadMutation",
    "operationKind": "mutation",
    "text": "mutation OrderEditInvoiceUploadMutation(\n  $id: ID!\n  $file: Upload!\n) {\n  uploadOrderInvoice(id: $id, file: $file) {\n    invoice {\n      ...StoredFile_file\n      id\n    }\n    id\n  }\n}\n\nfragment StoredFile_file on StoredFile {\n  fileName\n  size\n}\n"
  }
};
})();

(node as any).hash = "4b0e8e6065a00555824394b4a058e684";

export default node;
